import { redirect } from 'react-router';

import { BackupRoutesEnum } from 'src/pages/Backup';
import { BackupOnboardingRoutesEnum } from 'src/pages/BackupOnboarding';

import type { RouteObject } from 'react-router';

export const backupSingleRoutes: RouteObject = {
  path: 'backups/:id/*',
  lazy: async () => {
    const { BackupLayout } = await import('src/pages/Backup/ui');
    return { Component: BackupLayout };
  },
  loader: ({ params }) => {
    const { id, '*': path = '' } = params;
    if (!path) return redirect(`/backups/${id}/${BackupRoutesEnum.Overview}`);
    if (!Object.values(BackupRoutesEnum).includes(path as BackupRoutesEnum)) return redirect('/404');
    return null;
  },
  children: [
    {
      path: BackupRoutesEnum.Overview,
      lazy: async () => {
        const { default: Component } = await import('src/pages/Backup/Overview');
        return { Component };
      },
    },
    {
      path: BackupRoutesEnum.Uploads,
      lazy: async () => {
        const { default: Component } = await import('src/pages/Backup/Uploads');
        return { Component };
      },
    },
    {
      path: BackupRoutesEnum.Reports,
      lazy: async () => {
        const { default: Component } = await import('src/pages/Backup/Reports');
        return { Component };
      },
    },
    {
      path: BackupRoutesEnum.Settings,
      lazy: async () => {
        const { default: Component } = await import('src/pages/Backup/Settings');
        return { Component };
      },
    },
  ],
};

export const backupOnboardingRoutes: RouteObject = {
  path: 'backups/onboarding',
  children: [
    {
      path: 'new/:appId',
      lazy: async () => {
        const { default: Component } = await import('src/pages/BackupOnboarding/New');
        return { Component };
      },
    },
    {
      path: ':id/*',
      lazy: async () => {
        const { Layout } = await import('src/pages/BackupOnboarding/ui');
        return { Component: Layout };
      },
      children: [
        {
          path: BackupOnboardingRoutesEnum.NotificationSettings,
          lazy: async () => {
            const { default: Component } = await import('src/pages/BackupOnboarding/NotificationSettings');
            return { Component };
          },
        },
        {
          path: BackupOnboardingRoutesEnum.StorageSettings,
          lazy: async () => {
            const { default: Component } = await import('src/pages/BackupOnboarding/StorageSettings');
            return { Component };
          },
        },
        {
          path: BackupOnboardingRoutesEnum.Summary,
          lazy: async () => {
            const { default: Component } = await import('src/pages/BackupOnboarding/Summary');
            return { Component };
          },
        },
        {
          path: BackupOnboardingRoutesEnum.Details,
          lazy: async () => {
            const { default: Component } = await import('src/pages/BackupOnboarding/Details');
            return { Component };
          },
        },
      ],
    },
  ],
};
